module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_10-2c1aceeb6069100d8f4472eb73f3b124.jpg";